import { useTranslation } from 'next-i18next';

import { useBuildInfoContext } from '@/views/build/context';
import { useBuildFormContext } from '@/views/build/form/schema';
import { type SchoolType } from '@/views/build/type';
import { getGradeNumber } from '@/views/build/util';

export const useSelectSchoolPublisher = () => {
  const { watch, setValue } = useBuildFormContext();
  const { t } = useTranslation(['build', 'common']);

  const {
    publishers: _publishers,
    userCountryCode,
    schoolInfoTree,
  } = useBuildInfoContext();

  const selectedPublisher = watch('publisher');
  const gradeNumber = getGradeNumber(watch('gradeId'));

  const selectedSchoolType = schoolInfoTree.children
    .find(d => d.categoryTreeId === watch('schoolTypeId'))
    ?.name?.toLowerCase() as SchoolType;

  const selectedGrade = (() => {
    let mooreGrade = 0;
    // 한국기준으로만 되어있습니다
    if (selectedSchoolType === 'middle') {
      mooreGrade = 6;
    }
    if (selectedSchoolType === 'high') {
      mooreGrade = 9;
    }

    return gradeNumber + mooreGrade;
  })();

  const noneValue = 'none';

  /**
   *
   * 국가코드안에 숨겨진 학년을 제외하고 출판사 리스트목록을 가져온다
   * 한국 교과서만 일단 구현 햇으니 해외일경우 조심해야한다
   * */
  const publishers = [
    {
      label: t('build:select.unselect'),
      value: noneValue,
      hideGrades: [],
      showSchoolTypes: [
        'elementary',
        'other',
        'high',
        'middle',
        'primary',
        'graduate',
      ],
    },
    ...(_publishers?.[userCountryCode]?.filter(
      d =>
        d.showSchoolTypes?.includes(selectedSchoolType as SchoolType) &&
        !d.hideGrades.includes(selectedGrade || -1),
    ) || []),
  ];

  const isShowPublisher = (() => {
    if (
      !publishers ||
      publishers.filter(d => d.value !== noneValue).length === 0
    )
      return false;

    return Boolean(selectedGrade);
  })();

  return {
    isShowPublisher,
    publishers,
    selectedPublisher,
    selectedPublisherName:
      publishers.find(d => d.value === selectedPublisher)?.label || '',
    setPublisher: (value: string) => {
      setValue('publisher', value === noneValue ? '' : value);
    },
  };
};
